import type { DiagnosisType } from '@/shared/api/graphql/diagnosis';
import type { PatientsData } from '@/shared/lib/types/patients';
import type React from 'react';
import type { AccountDocumentType } from './accountDocuments';
import type { ClinicalCareEncounterType } from './clinicalCare';
import type { RpmFollowupConsultType } from './remotePatientMonitoring';

export type CcmAccountsType = Pick<
  PatientsData,
  | 'id'
  | 'truentityId'
  | 'user'
  | 'lastMedrecDate'
  | 'ccmStatus'
  | 'ccmEnrolledAt'
  | 'ccmUnenrolledAt'
  | 'rpmApprovalStatus'
  | 'rpmSignOffStatus'
  | 'healthPlan'
  | 'setting'
  | 'lastContacted'
  | 'phone'
  | 'tags'
> &
  Partial<Pick<PatientsData, 'birthDate' | 'zipcode' | 'phone' | 'doNotCall' | 'accountMetric'>> & {
    diagnoses?: DiagnosisType[];
    isLastVisitAsync?: boolean;
    lastCompletedFollowup?: RpmFollowupConsultType;
    lastCompletedVisitOn?: Date;
    lastClinicalCareEncounter?: ClinicalCareEncounterType;
    accountDocuments?: AccountDocumentType[];
    clinicalCareEncounterMode?: string;
  };

export enum CcmTabPathTypes {
  CANDIDATE = 'candidate',
  ELIGIBLE = 'eligible',
  INELIGIBLE = 'ineligible',
  IN_PROGRESS = 'inProgress',
  SCHEDULED = 'scheduled',
  ENROLLED = 'enrolled',
  ATTRIBUTED_ELSEWHERE = 'attributedElsewhere',
  UNENROLLED = 'unenrolled'
}

export type CcmPatientsTabType = {
  status: string;
  label: string;
  path: CcmTabPathTypes;
  icon: React.JSX.Element;
};

export enum CcmStatusTypes {
  ATTRIBUTED_ELSEWHERE = 'ATTRIBUTED_ELSEWHERE',
  IS_CANDIDATE = 'IS_CANDIDATE',
  IN_PROGRESS = 'IN_PROGRESS',
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  SCHEDULED = 'SCHEDULED',
  ENROLLED = 'ENROLLED',
  UNENROLLED = 'UNENROLLED'
}

export enum CcmReportActivityLogTypes {
  CCM_CARE_PLAN_REPORT_MAILED = 'Ccm::CarePlanReport::Mailed',
  CCM_CARE_PLAN_REPORT_HANDED_OVER = 'Ccm::CarePlanReport::HandedOver'
}
